import { filter, flatMap, maxBy, minBy } from "lodash";

// Genera 3 conclusiones + 3 acciones a partir de los datos ya calculados
// (buildProductSalesReport). Es texto por reglas simples sobre los números
// reales, no una interpretación "inteligente" — cada frase es trazable a un dato.
export function buildExecutiveSummary(report) {
  const { categories, totalRevenue } = report;
  const allProducts = flatMap(categories, "products");
  const withCost = filter(allProducts, "hasCost");

  const conclusions = [];
  const actions = [];

  const topCategory = maxBy(categories, "revenue");
  if (topCategory && totalRevenue > 0) {
    const share = ((topCategory.revenue / totalRevenue) * 100).toFixed(0);
    conclusions.push(
      `"${topCategory.title}" es la categoría con más ingresos del período: S/ ${topCategory.revenue.toFixed(2)} (${share}% del total).`
    );
  }

  const perros = filter(withCost, (p) => p.quadrant?.key === "PERRO");
  conclusions.push(
    perros.length > 0
      ? `${perros.length} producto(s) están en el cuadrante "Lastre" (bajo volumen y bajo margen) — candidatos a repensar o quitar del menú.`
      : `Ningún producto cayó en el cuadrante "Lastre" en este período — no hay candidatos obvios a retirar.`
  );

  const mostProfitable = maxBy(withCost, "margin");
  if (mostProfitable) {
    conclusions.push(
      `"${mostProfitable.title}" fue el producto más rentable en total: dejó S/ ${mostProfitable.margin.toFixed(2)} de margen en el período.`
    );
  }

  const bestPuzzle = maxBy(
    filter(withCost, (p) => p.quadrant?.key === "PUZZLE"),
    "margin"
  );
  if (bestPuzzle) {
    actions.push(
      `Promociona "${bestPuzzle.title}" como especial del día: deja buen margen (S/ ${bestPuzzle.margin.toFixed(2)}) pero se vendió poco (${bestPuzzle.quantity} unid.) — tiene espacio para crecer.`
    );
  }

  const topCaballo = maxBy(
    filter(withCost, (p) => p.quadrant?.key === "CABALLO"),
    "quantity"
  );
  if (topCaballo) {
    actions.push(
      `Revisa el costo o el precio de "${topCaballo.title}": es de los más vendidos (${topCaballo.quantity} unid.) pero deja poco margen por unidad — cualquier ajuste ahí se multiplica por el volumen.`
    );
  }

  const worstPerro = minBy(perros, "margin");
  if (worstPerro) {
    actions.push(
      `Reevalúa "${worstPerro.title}" (poca venta y poco margen): considera sacarlo del menú, reformularlo o subir su precio.`
    );
  }

  return { conclusions, actions };
}
